// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"4ff9421c","910":"717dd5cc"}[chunkId] + ".chunk.js";
};